import { useNavigate } from "react-router"
import useUserDataContext from "./useUserDataContext"
import { pathURL } from "@/components/constants/urls"

export const useLogoutHandler = () => {
  const { clearUserData } = useUserDataContext()
  const navigate = useNavigate()
  return () => {
    clearUserData()
    navigate(`/${pathURL.LOGIN}`)
  }
}
